import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export function MessageDialog(props) {
    const isError = props.message?.includes('Error') || props.message?.includes('⚠');
    
    return (
        <Modal 
            show={props.message !== null} 
            onHide={props.onHide}
            centered
            className="custom-modal"
        >
            <Modal.Header
                closeButton
                className={`modal-header ${isError ? 'error' : 'info'}`}
            >
                <Modal.Title className="modal-title">
                    {isError ? '[ERR] error' : '[OK] information'}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="modal-body">
                <div className="message-content">
                    <div className={`message-icon ${isError ? 'error' : 'info'}`}>
                        {isError ? '[ERR]' : '[OK]'}
                    </div>
                    <p className="message-text">{props.message}</p>
                </div>
            </Modal.Body>

            <Modal.Footer className="modal-footer">
                <Button
                    variant={isError ? "danger" : "primary"}
                    onClick={props.onHide}
                    className="modal-button"
                >
                    {isError ? '[ retry ]' : '[ close ]'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}